export default class BonusState {
  spentBonus = 0;
  customTitle: Nullable<string> = '';
}
